import type { DropdownProps } from 'antd';
import { Dropdown } from 'antd';
import styled from 'styled-components';

const StyledDropdown = styled((props: DropdownProps) => <Dropdown {...props} />)``;

export default StyledDropdown;
